import downArrow from "../public/hero/down-arrow.png";
import Celebration from "../public/hero/celebration.png";

const imageComponents = {
  downArrow,
  Celebration,
};

export default imageComponents;
